module.exports = __webpack_public_path__ + "static/img/s132.7ff5e0a1.png";